import { Component, Input, OnInit } from '@angular/core';
import { WebItem } from 'src/app/core/models/api/web-item.model';

@Component({
    selector: 'app-html-text',
    templateUrl: './html-text.component.html',
    styleUrls: ['./html-text.component.scss']
})
export class HtmlTextComponent implements OnInit {

    @Input() items: WebItem[];
    
    constructor() { }

    ngOnInit(): void {
    }

}
